
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Home from "./Home";
import Blog from "./Blog";
import About from "./About";
import Store from "./Store";
import Events from "./Events";
import Tournaments from "./Tournaments";
import Footer from "./layout/Footer";
import Navbar from "./layout/Navbar";
import Definition from "../definition";
import { IMerchItem } from "../data";
import { hostLogo } from "../helpers";
import styles from "../assets/style.module.css";
import { IHostWebsite, IMember } from "../../../../services";
import { useComponentStyle } from "../../../../hooks/useComponentStyle";
import { CacheManager, Utils, resolveTemplateColors } from "../../../../utils";

export interface LandingProps {
    basePath: string;
    publicId: string;
    website: IHostWebsite;
}

function Landing(props: LandingProps) {

    const location = ReactRouterDom.useLocation();
    const { website, basePath } = props;
    const [cart, setCart] = React.useState<IMerchItem[]>([]);
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [profile, setProfile] = React.useState<IMember | undefined>(CacheManager.get(CacheManager.PROFILE_KEY) as IMember);
    const colors = resolveTemplateColors(Definition, website.design_settings?.scheme_settings?.colors, searchParams);
    useComponentStyle(`
        :root {
            --paper: ${colors.background};
            --paper-alt: ${colors.background_alt};
            --ink: ${colors.surface_dark};
            --header-bg: ${colors.header_background};
            --text: ${colors.text};
            --text-soft: ${colors.text_soft};
            --gray: ${colors.text_muted};
            --white: ${colors.text_inverse};
            --stroke: ${colors.border};
            --primary: ${colors.primary};
            --on-primary: ${colors.on_primary};
            --green: ${colors.success};
            --red: ${colors.danger};
        }
    `);

    React.useEffect(() => {
        Utils.updateMeta({
            title: website.host.name,
            desc: website.host.short_info,
            logo: hostLogo(website)!,
        });
    }, [website]);

    React.useEffect(() => {
        if (!location.hash) window.scrollTo({ top: 0 });
    }, [location.pathname, location.hash]);

    return (<div className={styles["root"]}>
        <Navbar website={website} basePath={basePath} profile={profile} cartCount={cart.length} onSignOut={() => setProfile(undefined)} />
        <main className={styles["page"]}>
            <ReactRouterDom.Routes>
                <ReactRouterDom.Route path="/blog" element={<Blog website={website} />} />
                <ReactRouterDom.Route path="/about" element={<About website={website} />} />
                <ReactRouterDom.Route path="/events" element={<Events website={website} />} />
                <ReactRouterDom.Route path="/tournaments" element={<Tournaments website={website} />} />
                <ReactRouterDom.Route path="/merch" element={<Store cart={cart} onAddToCart={(item) => setCart((c) => (c.some((x) => x.id === item.id) ? c : [...c, item]))} />} />
                <ReactRouterDom.Route path="/" element={<Home website={website} basePath={basePath} />} />
            </ReactRouterDom.Routes>
        </main>
        <Footer website={website} basePath={basePath} profile={profile} />
    </div>);
}

export default Landing;
